import { z } from "zod";

export const ChecklistEntregaAmbienteCopiaSchema = z.object({
    idChecklistEntrega: z.number().int().optional(),
    ordem: z.string().nonempty({ message: "A ordem é obrigatória." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
});

export type ChecklistEntregaAmbienteCopiaForm = z.infer<typeof ChecklistEntregaAmbienteCopiaSchema>;

export const defaultChecklistEntregaAmbienteCopiaForm: Partial<ChecklistEntregaAmbienteCopiaForm> = {
    idChecklistEntrega: undefined,
    ordem: undefined,
    descricao: undefined,
};
